// extracted by mini-css-extract-plugin
export default {"inputContainer":"input_inputContainer__KMbbq","inputWrapper":"input_inputWrapper__tQE56","input":"input_input__WF92H","label":"input_label__7-6u-","shrink":"input_shrink__7XjeV"};